var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoading),expression:"showLoading"}],staticClass:"load-model"},[_c('lottie',{attrs:{"options":_vm.defaultOptions,"width":100,"height":100}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }